var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHistory = function SvgHistory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9 0a9 9 0 0 1 9 9 9 9 0 0 1-9 9 9 9 0 0 1-9-9h1.8a7.2 7.2 0 1 0 1.247-4.05H5.4v1.8H0v-5.4h1.8V3.6A8.98 8.98 0 0 1 9 0m.9 4.5v4.127l2.919 2.918-1.274 1.274L8.1 9.372V4.5z"
  })));
};
export default SvgHistory;